import React from 'react';
import {
  Dialog,
  IconButton,
  Button,
  Stack,
  useTheme
} from '@mui/material';
import { MdClose } from 'react-icons/md';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';

const PhoneNumberModal = ({ open, setOpen, user_name, phoneNumber }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const handleClose = () => {
    setOpen(false);
  };

  const handleCopy = () => {
    if (phoneNumber) {
      navigator.clipboard.writeText(phoneNumber);
      toast.success("Phone number copied!");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: isDark ? '#1a1a2e' : '#ffffff'
        },
      }}
    >
      <div className={`card h-100 radius-12 text-center position-relative mb-0 ${isDark ? 'bg-dark-mode border-dark' : ''}`}>
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: isDark ? '#2d3748' : 'background.default',
            color: isDark ? '#e5e7eb' : 'text.primary',
            '&:hover': {
              bgcolor: isDark ? '#4a5568' : 'background.paper'
            }
          }}
          size="small"
        >
          <MdClose size={20} />
        </IconButton>

        <div className="card-body p-24">
          {/* Phone Icon */}
          <div className="w-64-px h-64-px d-inline-flex align-items-center justify-content-center bg-primary-600 text-white mb-16 radius-12">
            <Icon icon="akar-icons:phone" className="h5 mb-0" />
          </div>

          {/* User Name */}
          {user_name && (
            <h6 className="mb-8" style={{ color: isDark ? '#f3f4f6' : '#111827' }}>
              {user_name}
            </h6>
          )}

          {/* Phone Number */}
          <p
            className="card-text mb-16 fw-bold"
            style={{ 
              fontSize: '32px',
              color: isDark ? '#e5e7eb' : '#374151'
            }}
          >
            {phoneNumber}
          </p>

          {/* Copy Button */}
          <Stack direction="row" justifyContent="center" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCopy}
              startIcon={<Icon icon="mdi:content-copy" />}
              sx={{
                borderRadius: 2,
                px: 3,
                bgcolor: isDark ? '#3b82f6' : undefined,
                '&:hover': {
                  bgcolor: isDark ? '#2563eb' : undefined
                }
              }}
            >
              Copy Number
            </Button>
          </Stack>
        </div>
      </div>
    </Dialog>
  );
};

export default PhoneNumberModal;
